export default "__VITE_ASSET__B04Tq9ij__"